@if (currentContactInfos(); as contactInfos) {
  <div class="flex flex-col justify-between">
    <div class="flex flex-col gap-1 py-2">
      <div class="text-xl leading-none font-semibold tracking-tight">Adresse e-mail</div>
      <div class="text-gray-11">{{ contactInfos.email | obfuscateEmail }}</div>
    </div>
  </div>
}
